import HTMLReactParser from "html-react-parser"
import { Image, RatioImage } from "@components/anti/Image"
import Link from "@components/anti/Link"
import { useScrollAnim } from "src/hooks/hooks"

import xxiBg from "@public/img/bg/img_bg-xxi-transparent.png"
import { translations } from "src/helper/translations"
import { convertHtmlToReact } from "src/mixins"

function HomeAbout({ data, locale }) {
  const [trigger, anim, inView] = useScrollAnim("fadeInUp", [0.125, 0.5, 0.75])
  const { cinemaInNumbers } = data
  return (
    <section className="sc-home-about " ref={trigger}>
      {/* <div className="cinema-gradient" /> */}
      <div className="py-5">
        <div className="container">
          <div className="row row-0">
            <div className="col-md-4 col-title">
              <h2 className={`title text-gradient ${anim(1)}`}>
                {data && data[`title_${locale}`]}
              </h2>
              <Link
                href={data?.link_url}
                withArrow
                className={`text-capitalize ${anim(3)}`}
              >
                {data[`link_label_${locale}`]}
              </Link>
            </div>
            <div className="col-md-8 col-text">
              <Image
                src={xxiBg}
                className={`img-fluid bg-xxi ${inView ? "in-view" : ""}`}
                alt="bg-xxi"
              />
              <div className="col-text_content">
                <div className={`text ${anim(5, "fadeInUp7")}`}>
                  {convertHtmlToReact(data[`description_${locale}`])}
                </div>
                <hr />
                <div className="cinema-in-number">
                  <p
                    className={`cinema-in-number_title ${anim(7, "fadeInUp4")}`}
                  >
                    {cinemaInNumbers[`title_${locale}`]}
                  </p>
                  <div className="cinema-in-number_content">
                    <div className="cinema-in-number_content-item">
                      <h4
                        className={`cinema-in-number_content-item_value ${anim(
                          9
                        )}`}
                      >
                        {cinemaInNumbers.lokasi}
                      </h4>
                      <p
                        className={`cinema-in-number_content-item_label ${anim(
                          17,
                          "fadeInUp4"
                        )}`}
                      >
                        {translations[`location_${locale}`]}
                      </p>
                    </div>
                    <div className="cinema-in-number_content-item">
                      <h4
                        className={`cinema-in-number_content-item_value ${anim(
                          12
                        )}`}
                      >
                        {locale === "en"
                          ? cinemaInNumbers?.layar?.replace(".", ",")
                          : cinemaInNumbers?.layar}
                      </h4>
                      <p
                        className={`cinema-in-number_content-item_label ${anim(
                          19,
                          "fadeInUp4"
                        )}`}
                      >
                        {translations[`screen_${locale}`]}
                      </p>
                    </div>
                    {/* <div className="cinema-in-number_content-item">
                      <h4
                        className={`cinema-in-number_content-item_value ${anim(
                          15
                        )}`}
                      >
                        {cinemaInNumbers?.kota}
                      </h4>
                      <p
                        className={`cinema-in-number_content-item_label ${anim(
                          21,
                          "fadeInUp4"
                        )}`}
                      >
                        {translations[`city_in_${locale}`]}
                      </p>
                    </div> */}
                  </div>
                </div>
                <div className={`text-last-update ${anim(20, "fadeInUp5")}`}>
                  {cinemaInNumbers[`last_update_label_${locale}`]}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeAbout
